import React, { useState, useEffect } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import { useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

const DashboardOM = () => {
  let { orderId } = useParams();
  const [orderData, setOrderData] = useState(null);
  const [comboData1, setComboData1] = useState(null);
  const [comboData2, setComboData2] = useState(null);
  const [comboData3, setComboData3] = useState(null);
  const [banco, setBanco] = useState('');
  const [metodoPago, setMetodoPago] = useState('');
  const [numeroReferencia, setNumeroReferencia] = useState('');
  const [monto, setMonto] = useState('');
  const [base64Image, setBase64Image] = useState(null);
  const [fileExtension, setFileExtension] = useState(null);
  const [codigoabonoimg, setCodigoabonoimg] = useState(null);
  const [pend, setPendiente] = useState('');
  const [NumFact, setNumFact] = useState(0);
  const [showPreviewModal, setShowPreviewModal] = useState(false);
  const [previewUrl, setPreviewUrl] = useState('');
  const [previewType, setPreviewType] = useState('');
  const [previewTipoObjeto, setPreviewTipoObjeto] = useState('');
  const [abonosConImagenes, setAbonosConImagenes] = useState([]);
  const [loadingAbonos, setLoadingAbonos] = useState(false);
  const [totalProductos, setTotalProductos] = useState(0);
  
  // Estados para control de zoom de imagen
  const [zoomLevel, setZoomLevel] = useState(1);
  const [position, setPosition] = useState({ x: 0, y: 0 });
  const [isDragging, setIsDragging] = useState(false);
  const [dragStart, setDragStart] = useState({ x: 0, y: 0 });
  
  const dispatch = useDispatch();
  const { token, user } = useSelector(state => state.auth);
  const navigate = useNavigate();

  // Función para determinar el tipo MIME basado en la extensión
  const getMimeType = (extension) => {
    const mimeTypes = {
      'jpg': 'data:image/jpeg;base64,',
      'jpeg': 'data:image/jpeg;base64,',
      'png': 'data:image/png;base64,',
      'gif': 'data:image/gif;base64,',
      'bmp': 'data:image/bmp;base64,',
      'pdf': 'data:application/pdf;base64,',
      'doc': 'data:application/msword;base64,',
      'docx': 'data:application/vnd.openxmlformats-officedocument.wordprocessingml.document;base64,',
      'xlsx': 'data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,',
      'txt': 'data:text/plain;charset=utf-8;base64,'
    };
    
    return mimeTypes[extension.toLowerCase()] || 'data:application/octet-stream;base64,';
  };

  // Función para construir la URL completa con el prefijo correcto
  const buildDataUrl = (base64Data, extension) => {
    const mimePrefix = getMimeType(extension);
    // Si ya tiene el prefijo, retornar tal cual
    if (base64Data.startsWith('data:')) {
      return base64Data;
    }
    // Si no tiene prefijo, agregarlo
    return `${mimePrefix}${base64Data}`;
  };

  // Efecto para cargar datos de la orden y abonos
  useEffect(() => {
    const fetchData = async () => {
      try {
        // Primera llamada API para datos específicos de la orden
        const datosMetodo1 = {
          NombreMetodo: "BuscarInfoOMEspecifico",
          Datos_Recibidos: `{"FECHAINI":"06/05/2024","FECHAFIN":"06/05/2024","CODOV":"${orderId}"}`
        };

        const datos1 = {
          Token: "LJKNFUH2FWEJBAEFFFFFKJ VGDEA003CSFCAQWEUIRRRRRRRRRRRADFYGBIFHVBESRNYHIOPWJROTY4WY",
          Ambiente: "DESA",
          Dispositivo: {
            Marca: "SAMSUNG",
            Modelo: "S22002B",
            Version: "Android 18.125",
            McAdress: null,
            PowerStatus: "84%",
            WifiStatus: "Conected to iphone de Mauricio",
            GPSStatus: "ON",
            GPS: "321|-485|321"
          },
          Usr: {
            Codigo: "",
            UserNickName: "pierril"
          },
          DatosMetodo: datosMetodo1
        };

        // Segunda llamada API para combos
        const datosMetodo2 = {
          NombreMetodo: "ListaCombosAbono",
          Datos_Recibidos: "",
          Datos_Generados: ""
        };

        const datos2 = {
          Token: "LJKNFUH2FWEJBAEFFFFFKJ VGDEA003CSFCAQWEUIRRRRRRRRRRRADFYGBIFHVBESRNYHIOPWJROTY4WY",
          Ambiente: "DESA",
          Dispositivo: {
            Marca: "SAMSUNG",
            Modelo: "S22002B",
            Version: "Android 18.125",
            McAdress: "22222",
            PowerStatus: "84%",
            WifiStatus: "Conected to iphone de Mauricio",
            GPSStatus: "ON",
            GPS: "321|-485|321"
          },
          Usr: {
            Codigo: "",
            UserNickName: "pierril"
          },
          DatosMetodo: datosMetodo2
        };

        // Realizar ambas llamadas API simultáneamente
        const fetchDataUrl1 = `https://appcorp.parma.com.gt/API/ReceptorDatos?Datos=${encodeURIComponent(JSON.stringify(datos1))}`;
        const fetchDataUrl2 = `https://appcorp.parma.com.gt/API/ReceptorDatos?Datos=${encodeURIComponent(JSON.stringify(datos2))}`;

        const [response1, response2] = await Promise.all([
          fetch(fetchDataUrl1),
          fetch(fetchDataUrl2)
        ]);

        const data1 = await response1.json();
        const data2 = await response2.json();

        const parsedData1 = JSON.parse(data1.datos_Generados);
        const parsedData2 = JSON.parse(data2.datos_Generados);

        // Configurar datos de la orden
        setOrderData(parsedData1);

        // Filtrar y configurar combos
        const abonoOptions = parsedData2.LISTACOMBO.filter(item => item.TipoCombo === 'Abono');
        const bancoOptions = parsedData2.LISTACOMBO.filter(item => item.TipoCombo === 'Banco');
        const medioPagoOptions = parsedData2.LISTACOMBO.filter(item => item.TipoCombo === 'MedioPago');

        setComboData1(abonoOptions);
        setComboData2(bancoOptions);
        setComboData3(medioPagoOptions);

        // Calcular monto pendiente
        if (parsedData1 && parsedData1[0]) {
          const total = parsedData1[0].Total || 0;
          const montoPagado = parsedData1[0].MontoPagado || 0;
          const Mpend = (total - montoPagado).toFixed(2);
          setPendiente(Mpend);
          setMonto(Mpend);
        }

        // Contar número de facturas
        if (parsedData1 && parsedData1[0] && parsedData1[0].Documentos) {
          const documentos = parsedData1[0].Documentos;
          const numFactCount = documentos.filter(doc => doc.Tipo === "6")?.length || 0;
          setNumFact(numFactCount);
        }

        // Calcular total de productos y líneas
        if (parsedData1 && parsedData1[0] && parsedData1[0].Productos) {
          const productosFiltrados = parsedData1[0].Productos.filter(
            producto => producto.Precio && producto.CantidadFactura
          );
          setTotalProductos(productosFiltrados.length);
        }

        // Cargar abonos con imágenes
        await cargarAbonosConImagenes();

      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };

    fetchData();
  }, [orderId]);

  // Función para cargar abonos con imágenes
  const cargarAbonosConImagenes = async () => {
    setLoadingAbonos(true);
    try {
      const datosMetodo = {
        NombreMetodo: "ObtenerAbonosConImagenes",
        Datos_Recibidos: `{"CODOV":"${orderId}"}`,
        Datos_Generados: ""
      };

      const datos = {
        Token: "LJKNFUH2FWEJBAEFFFFFKJ VGDEA003CSFCAQWEUIRRRRRRRRRRRADFYGBIFHVBESRNYHIOPWJROTY4WY",
        Ambiente: "DESA",
        Dispositivo: {
          Marca: "SAMSUNG",
          Modelo: "S22002B",
          Version: "Android 18.125",
          McAdress: null,
          PowerStatus: "84%",
          WifiStatus: "Conected to iphone de Mauricio",
          GPSStatus: "ON",
          GPS: "321|-485|321"
        },
        Usr: {
          Codigo: "",
          UserNickName: "pierril"
        },
        DatosMetodo: datosMetodo
      };

      const response = await fetch(
        `https://appcorp.parma.com.gt/API/ReceptorDatos?Datos=${encodeURIComponent(JSON.stringify(datos))}`
      );

      const data = await response.json();
      
      if (data.datos_Generados) {
        const parsedData = JSON.parse(data.datos_Generados);
        
        // Procesar cada abono para construir las URLs correctamente
        const abonosProcesados = parsedData.map(abono => {
          if (abono.ImagenBase64 && abono.Extension) {
            // Construir la URL completa con el prefijo correcto
            abono.ImagenCompleta = buildDataUrl(abono.ImagenBase64, abono.Extension);
            
            // Determinar el tipo para preview
            const extensionLower = abono.Extension.toLowerCase();
            if (['jpg', 'jpeg', 'png', 'gif', 'bmp'].includes(extensionLower)) {
              abono.TipoPreview = 'image';
            } else if (extensionLower === 'pdf') {
              abono.TipoPreview = 'pdf';
            } else {
              abono.TipoPreview = 'other';
            }
          }
          return abono;
        });
        
        setAbonosConImagenes(abonosProcesados);
      }
    } catch (error) {
      console.error('Error cargando abonos con imágenes:', error);
    } finally {
      setLoadingAbonos(false);
    }
  };

  // Manejar cambio de imagen
  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const extension = file.name.split('.').pop();
      setFileExtension(extension);

      const reader = new FileReader();
      reader.onloadend = () => {
        setBase64Image(reader.result);
      };
      reader.readAsDataURL(file);
    }
  };

  // Manejar preview de documento
  const handlePreview = (url, tipoObjeto = '', tipo = 'unknown') => {
    setPreviewUrl(url);
    setPreviewType(tipo);
    setPreviewTipoObjeto(tipoObjeto);
    
    // Reiniciar controles de zoom
    setZoomLevel(1);
    setPosition({ x: 0, y: 0 });
    
    // Si es WEB, abrir en nueva pestaña
    if (tipoObjeto === 'WEB' && url) {
      window.open(url, '_blank');
      return;
    }
    
    // Si es IMAGEN u otro tipo, mostrar modal
    setShowPreviewModal(true);
  };

  // Manejar preview de abono
  const handlePreviewAbono = (abono) => {
    if (abono.ImagenCompleta) {
      setPreviewUrl(abono.ImagenCompleta);
      setPreviewType(abono.TipoPreview);
      setPreviewTipoObjeto('IMAGEN'); // Para abonos siempre es IMAGEN
      
      // Reiniciar controles de zoom
      setZoomLevel(1);
      setPosition({ x: 0, y: 0 });
      
      setShowPreviewModal(true);
    }
  };

  // Cerrar preview
  const handleClosePreview = () => {
    setShowPreviewModal(false);
    setPreviewUrl('');
    setPreviewType('');
    setPreviewTipoObjeto('');
    setZoomLevel(1);
    setPosition({ x: 0, y: 0 });
  };

  // Funciones para control de zoom de imagen
  const handleZoomIn = () => {
    setZoomLevel(prev => Math.min(prev + 0.25, 3));
  };

  const handleZoomOut = () => {
    setZoomLevel(prev => Math.max(prev - 0.25, 0.5));
  };

  const handleZoomReset = () => {
    setZoomLevel(1);
    setPosition({ x: 0, y: 0 });
  };

  // Manejar eventos de arrastre para la imagen
  const handleMouseDown = (e) => {
    if (zoomLevel > 1) {
      setIsDragging(true);
      setDragStart({
        x: e.clientX - position.x,
        y: e.clientY - position.y
      });
    }
  };

  const handleMouseMove = (e) => {
    if (isDragging && zoomLevel > 1) {
      setPosition({
        x: e.clientX - dragStart.x,
        y: e.clientY - dragStart.y
      });
    }
  };

  const handleMouseUp = () => {
    setIsDragging(false);
  };

  // Efecto para manejar eventos globales de mouse
  useEffect(() => {
    if (isDragging) {
      document.addEventListener('mousemove', handleMouseMove);
      document.addEventListener('mouseup', handleMouseUp);
      
      return () => {
        document.removeEventListener('mousemove', handleMouseMove);
        document.removeEventListener('mouseup', handleMouseUp);
      };
    }
  }, [isDragging, dragStart]);

  // Enviar datos del abono
  const handleSubmit = () => {
    const codigoOrderId = parseInt(orderId.replace(/\D/g, ''), 10);
    const idusuarioenvia = user.id_usuario;

    // El tipo de pago siempre será 1 (Pago Total)
    const tipoPago = 1;
    let metodoPagoEntero = parseInt(metodoPago, 10);

    const datosRecibidos = {
      AcovTipoabono: tipoPago,
      AcovTipoReferencia: metodoPagoEntero,
      AcovNoReferencia: numeroReferencia,
      AcovCodov: codigoOrderId,
      AcovMonto: parseFloat(monto),
      AcovValidado: 1,
      AcovUsuario: parseInt(idusuarioenvia, 10),
      AcovCodBanco: parseInt(banco, 10)
    };

    const payload = {
      Token: "LJKNFUH2FWEJBAEFFFFFKJ VGDEA003CSFCAQWEUIRRRRRRRRRRRADFYGBIFHVBESRNYHIOPWJROTY4WY",
      User: {
        Codigo: "2165",
        UserNickName: "pierril"
      },
      Metodo: {
        NombreMetodo: "CrearAbono",
        Datos_Recibidos: JSON.stringify(datosRecibidos),
        Datos_Generados: ""
      }
    };

    fetch('https://appcorp.parma.com.gt/API/ReceptorDatos', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(payload)
    })
      .then(response => response.json())
      .then(data => {
        const datosGenerados = JSON.parse(data.datos_Generados);
        if (datosGenerados && datosGenerados.length > 0) {
          const codigoAbono = datosGenerados[0].CodigoAbono;
          setCodigoabonoimg(codigoAbono);
          if (codigoAbono && base64Image) {
            handleSumbmitAffter(codigoAbono);
          } else {
            alert('ABONO CREADO EXITOSAMENTE, NO. ABONO ' + codigoAbono);
            // Recargar la lista de abonos después de crear uno nuevo
            cargarAbonosConImagenes();
          }
        } else {
          console.log("No se encontró ningún Código de Abono.");
        }
      })
      .catch((error) => {
        console.error('Error:', error);
        alert('Error al crear el abono');
      });
  };

  // Enviar imagen del abono después de crear el registro
  const handleSumbmitAffter = (codigoAbono) => {
    const soloBase64 = base64Image.split('base64,')[1].trim();

    const datosRecibidos = {
      Codigo: codigoAbono.toString(),
      Imagen: soloBase64,
      Extension: fileExtension
    };

    const payload = {
      Token: "LJKNFUH2FWEJBAEFFFFFKJ VGDEA003CSFCAQWEUIRRRRRRRRRRRADFYGBIFHVBESRNYHIOPWJROTY4WY",
      User: {
        Codigo: "2165",
        UserNickName: "pierril"
      },
      Metodo: {
        NombreMetodo: "CargarImagenAbono",
        Datos_Recibidos: JSON.stringify(datosRecibidos),
        Datos_Generados: ""
      }
    };

    fetch('https://appcorp.parma.com.gt/API/ReceptorDatos', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(payload)
    })
      .then(response => response.json())
      .then(data => {
        alert('ABONO CREADO EXITOSAMENTE, NO. ABONO ' + codigoAbono);
        // Recargar la lista de abonos después de subir la imagen
        cargarAbonosConImagenes();
      })
      .catch((error) => {
        console.error('Error:', error);
        alert('Error al cargar la imagen del abono');
      });
  };

  // Función para obtener el icono según la extensión
  const getIconForExtension = (extension) => {
    const ext = extension ? extension.toLowerCase() : '';
    if (['jpg', 'jpeg', 'png', 'gif', 'bmp'].includes(ext)) {
      return 'fas fa-image';
    } else if (ext === 'pdf') {
      return 'fas fa-file-pdf';
    } else if (['doc', 'docx'].includes(ext)) {
      return 'fas fa-file-word';
    } else if (['xlsx', 'xls'].includes(ext)) {
      return 'fas fa-file-excel';
    } else if (ext === 'txt') {
      return 'fas fa-file-alt';
    }
    return 'fas fa-file';
  };

  // Función para obtener el icono según el tipo de objeto
  const getIconForTipoObjeto = (tipoObjeto) => {
    switch(tipoObjeto?.toUpperCase()) {
      case 'IMAGEN': return 'fas fa-image';
      case 'WEB': return 'fas fa-globe';
      case 'PDF': return 'fas fa-file-pdf';
      default: return 'fas fa-file';
    }
  };

  // Función para formatear fecha
  const formatFecha = (fechaStr) => {
    if (!fechaStr) return '';
    try {
      const fecha = new Date(fechaStr);
      return fecha.toLocaleDateString('es-GT', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric'
      });
    } catch (e) {
      return fechaStr;
    }
  };

  // Función para calcular total de línea
  const calcularTotalLinea = (precio, cantidad) => {
    if (!precio || !cantidad) return 0;
    const precioNum = parseFloat(precio);
    const cantidadNum = parseFloat(cantidad);
    return (precioNum * cantidadNum).toFixed(2);
  };

  // Función para calcular total general de productos
  const calcularTotalGeneralProductos = () => {
    if (!orderData || !orderData[0] || !orderData[0].Productos) return 0;
    
    return orderData[0].Productos
      .filter(producto => producto.Precio && producto.CantidadFactura)
      .reduce((total, producto) => {
        const precio = parseFloat(producto.Precio) || 0;
        const cantidad = parseFloat(producto.CantidadFactura) || 0;
        return total + (precio * cantidad);
      }, 0)
      .toFixed(2);
  };

  // Filtrar productos que tengan precio y cantidad
  const productosFiltrados = () => {
    if (!orderData || !orderData[0] || !orderData[0].Productos) return [];
    
    return orderData[0].Productos.filter(
      producto => producto.Precio && producto.CantidadFactura
    );
  };

  return (
    <div className="container-fluid bg-light min-vh-100 py-4">
      {/* Header */}
      <header className="p-3 border-bottom bg-white rounded-3 shadow-sm mb-4">
        <div className="d-flex justify-content-between align-items-center">
          <h4 className="mb-0 text-primary">
            <i className="fas fa-clipboard-list me-2"></i>
            Dashboard de Orden
          </h4>
          <span className="badge bg-info fs-6">ID: {orderId}</span>
        </div>
      </header>

      {/* Botón de Pago Anticipado */}
      <div className="row mb-4">
        <div className="col-12">
          <div className="d-flex justify-content-between align-items-center">
            <h2 className="h5 text-muted">Detalles de la Orden</h2>
            {(Number(pend) > 0 || NumFact === 0) && 
              !user.rol.some(rol => rol.Id_Perfil === 170000 || rol.Id_Perfil === 170010 || rol.Id_Perfil === 170020) && (
              <button
                type="button"
                className="btn btn-warning btn-lg shadow-sm"
                data-bs-toggle="modal"
                data-bs-target="#pagoModal"
                style={{ 
                  fontSize: '1.1rem',
                  fontWeight: '600',
                  borderRadius: '10px',
                  padding: '12px 24px'
                }}
              >
                <i className="fas fa-money-bill-wave me-2"></i>
                Pago Anticipado (Pendiente: Q {pend})
              </button>
            )}
          </div>
        </div>
      </div>

      {/* Datos Generales */}
      <div className="row mb-4">
        <div className="col-12">
          <div className="card border-0 shadow-sm">
            <div className="card-header bg-primary text-white rounded-top">
              <h5 className="mb-0">
                <i className="fas fa-info-circle me-2"></i>
                Datos Generales
              </h5>
            </div>
            <div className="card-body">
              <div className="row">
                <div className="col-md-6 mb-3">
                  <h6 className="text-secondary mb-3">
                    <i className="fas fa-user me-2"></i>
                    Datos del Cliente
                  </h6>
                  {orderData && orderData[0] && orderData[0].Cliente && (
                    <div className="ps-3">
                      <p className="mb-2">
                        <span className="text-muted">Nombre:</span>
                        <span className="ms-2 fw-semibold">{orderData[0].Cliente.Nombre}</span>
                      </p>
                      <p className="mb-2">
                        <span className="text-muted">Contacto Créditos:</span>
                        <span className="ms-2">{orderData[0].Cliente.ContactoCreditos}</span>
                      </p>
                      <p className="mb-0">
                        <span className="text-muted">Contacto Ventas:</span>
                        <span className="ms-2">{orderData[0].Cliente.ContactoVentas}</span>
                      </p>
                    </div>
                  )}
                </div>
                <div className="col-md-6">
                  <h6 className="text-secondary mb-3">
                    <i className="fas fa-truck me-2"></i>
                    Datos de Envío
                  </h6>
                  {orderData && orderData[0] && orderData[0].Cliente && (
                    <div className="ps-3">
                      <p className="mb-2">
                        <span className="text-muted">Dirección Fiscal:</span>
                        <span className="ms-2 fw-semibold">{orderData[0].Cliente.DireccionRS}</span>
                      </p>
                      <p className="mb-0">
                        <span className="text-muted">Dirección Entrega:</span>
                        <span className="ms-2">{orderData[0].Cliente.DireccionEN}</span>
                      </p>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Modal de Pago */}
      <div className="modal fade" id="pagoModal" tabIndex="-1" aria-labelledby="pagoModalLabel" aria-hidden="true">
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content border-0 shadow-lg">
            <div className="modal-header bg-primary text-white rounded-top">
              <h5 className="modal-title" id="pagoModalLabel">
                <i className="fas fa-credit-card me-2"></i>
                Pago Anticipado
              </h5>
              <button type="button" className="btn-close btn-close-white" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div className="modal-body p-4">
              {/* Información del monto */}
              <div className="alert alert-info mb-4">
                <div className="d-flex align-items-center">
                  <i className="fas fa-info-circle fa-2x me-3 text-info"></i>
                  <div>
                    <h6 className="mb-1">Monto a Pagar</h6>
                    <p className="mb-0 fs-5 fw-bold">Q {pend}</p>
                    <small className="text-muted">Este valor corresponde al saldo pendiente total.</small>
                  </div>
                </div>
              </div>

              {/* Método de Pago */}
              <div className="mb-4">
                <label htmlFor="metodoPago" className="form-label fw-semibold">
                  <i className="fas fa-wallet me-2"></i>
                  Método de Pago
                </label>
                <select
                  id="metodoPago"
                  className="form-select form-select-lg"
                  value={metodoPago}
                  onChange={(e) => setMetodoPago(e.target.value)}
                >
                  <option value="">Seleccione un método...</option>
                  {comboData3 && comboData3.length > 0 ? (
                    comboData3.map((metodo) => (
                      <option key={metodo.Codigo} value={metodo.Codigo}>
                        {metodo.Descripcion}
                      </option>
                    ))
                  ) : (
                    <option value="">Cargando opciones...</option>
                  )}
                </select>
              </div>

              {/* Banco (solo si no es método 4 o VisaLink) */}
              {!(metodoPago === "4" || metodoPago === "Visalink") && (
                <div className="mb-4">
                  <label htmlFor="banco" className="form-label fw-semibold">
                    <i className="fas fa-university me-2"></i>
                    Banco
                  </label>
                  <select
                    id="banco"
                    className="form-select form-select-lg"
                    value={banco}
                    onChange={(e) => setBanco(e.target.value)}
                  >
                    <option value="">Seleccione un banco...</option>
                    {comboData2 && comboData2.length > 0 ? (
                      comboData2.map((banco) => (
                        <option key={banco.Codigo} value={banco.Codigo}>
                          {banco.Descripcion}
                        </option>
                      ))
                    ) : (
                      <option value="">Cargando opciones...</option>
                    )}
                  </select>
                </div>
              )}

              {/* Número de Referencia */}
              <div className="mb-4">
                <label htmlFor="numeroReferencia" className="form-label fw-semibold">
                  <i className="fas fa-hashtag me-2"></i>
                  Número de Referencia
                </label>
                <input
                  type="text"
                  className="form-control form-control-lg"
                  id="numeroReferencia"
                  value={numeroReferencia}
                  onChange={(e) => setNumeroReferencia(e.target.value)}
                  placeholder="Ingrese el número de referencia"
                />
              </div>

              {/* Monto (solo lectura) */}
              <div className="mb-4">
                <label htmlFor="monto" className="form-label fw-semibold">
                  <i className="fas fa-money-bill-wave me-2"></i>
                  Monto
                </label>
                <div className="input-group input-group-lg">
                  <span className="input-group-text bg-light">Q</span>
                  <input
                    type="text"
                    className="form-control"
                    id="monto"
                    value={pend}
                    readOnly
                    style={{ backgroundColor: '#f8f9fa' }}
                  />
                </div>
                <small className="text-muted mt-1 d-block">Este es el monto pendiente total que se pagará.</small>
              </div>

              {/* Cargar Imagen */}
              <div className="mb-4">
                <label htmlFor="imagen" className="form-label fw-semibold">
                  <i className="fas fa-image me-2"></i>
                  Comprobante de Pago
                </label>
                <div className="border rounded p-3 text-center bg-light">
                  <input
                    type="file"
                    className="form-control form-control-lg"
                    id="imagen"
                    onChange={handleImageChange}
                    accept="image/*,.pdf,.doc,.docx,.xlsx,.txt"
                  />
                  <small className="text-muted mt-2 d-block">
                    Suba un comprobante (JPG, PNG, PDF, DOC, XLSX, TXT)
                  </small>
                </div>
              </div>
            </div>
            <div className="modal-footer border-top-0">
              <button
                type="button"
                className="btn btn-outline-secondary btn-lg"
                data-bs-dismiss="modal"
              >
                Cancelar
              </button>
              <button
                type="button"
                className="btn btn-primary btn-lg"
                onClick={handleSubmit}
                disabled={!metodoPago || !numeroReferencia || !base64Image}
              >
                <i className="fas fa-paper-plane me-2"></i>
                Enviar Pago
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Modal de Preview */}
      <div className={`modal fade ${showPreviewModal ? 'show d-block' : ''}`} tabIndex="-1" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
        <div className="modal-dialog modal-dialog-centered modal-xl">
          <div className="modal-content">
            <div className="modal-header bg-primary text-white">
              <h5 className="modal-title">
                <i className={getIconForTipoObjeto(previewTipoObjeto)} me-2></i>
                Vista Previa {previewTipoObjeto ? `(${previewTipoObjeto})` : ''}
              </h5>
              <button type="button" className="btn-close btn-close-white" onClick={handleClosePreview}></button>
            </div>
            
            {/* Controles de zoom para imágenes */}
            {previewTipoObjeto === 'IMAGEN' && previewType === 'image' && (
              <div className="modal-header bg-light border-bottom py-2">
                <div className="d-flex justify-content-between align-items-center">
                  <div className="btn-group">
                    <button 
                      type="button" 
                      className="btn btn-outline-primary btn-sm"
                      onClick={handleZoomOut}
                      disabled={zoomLevel <= 0.5}
                      title="Zoom Out"
                    >
                      <i className="fas fa-search-minus"></i>
                    </button>
                    <button 
                      type="button" 
                      className="btn btn-outline-primary btn-sm"
                      onClick={handleZoomReset}
                      title="Reset Zoom"
                    >
                      {Math.round(zoomLevel * 100)}%
                    </button>
                    <button 
                      type="button" 
                      className="btn btn-outline-primary btn-sm"
                      onClick={handleZoomIn}
                      disabled={zoomLevel >= 3}
                      title="Zoom In"
                    >
                      <i className="fas fa-search-plus"></i>
                    </button>
                  </div>
                  <div className="text-muted small">
                    <i className="fas fa-arrows-alt me-1"></i>
                    {zoomLevel > 1 ? 'Arrastra para mover la imagen' : 'Zoom disponible'}
                  </div>
                </div>
              </div>
            )}
            
            <div className="modal-body text-center p-0 position-relative">
              {previewTipoObjeto === 'IMAGEN' && previewType === 'image' ? (
                <div 
                  className="overflow-hidden position-relative"
                  style={{ 
                    height: '70vh',
                    cursor: zoomLevel > 1 ? (isDragging ? 'grabbing' : 'grab') : 'default'
                  }}
                  onMouseDown={handleMouseDown}
                >
                  <img 
                    src={previewUrl} 
                    alt="Preview" 
                    className="position-absolute"
                    style={{ 
                      transform: `translate(${position.x}px, ${position.y}px) scale(${zoomLevel})`,
                      transformOrigin: 'center center',
                      transition: isDragging ? 'none' : 'transform 0.1s',
                      maxWidth: 'none',
                      maxHeight: 'none'
                    }} 
                  />
                </div>
              ) : previewType === 'pdf' ? (
                <iframe
                  src={previewUrl}
                  title="PDF Preview"
                  className="w-100 rounded"
                  style={{ height: '70vh', border: 'none' }}
                />
              ) : previewTipoObjeto === 'WEB' ? (
                <div className="alert alert-info m-4">
                  <i className="fas fa-external-link-alt fa-2x mb-3"></i>
                  <h5>Enlace WEB</h5>
                  <p>Este documento es un enlace web que se abrirá en una nueva pestaña.</p>
                  <a href={previewUrl} className="btn btn-primary mt-2" target="_blank" rel="noopener noreferrer">
                    <i className="fas fa-external-link-alt me-2"></i>
                    Abrir en nueva pestaña
                  </a>
                </div>
              ) : (
                <div className="alert alert-warning m-4">
                  <i className="fas fa-exclamation-triangle fa-2x mb-3"></i>
                  <h5>No se puede mostrar la vista previa</h5>
                  <p>El formato del archivo no es compatible para vista previa directa.</p>
                  <a href={previewUrl} className="btn btn-primary mt-2" target="_blank" rel="noopener noreferrer" download>
                    <i className="fas fa-download me-2"></i>
                    Descargar Archivo
                  </a>
                </div>
              )}
            </div>
            <div className="modal-footer">
              <button type="button" className="btn btn-secondary" onClick={handleClosePreview}>
                Cerrar
              </button>
              {previewTipoObjeto !== 'WEB' && (
                <a href={previewUrl} className="btn btn-primary" target="_blank" rel="noopener noreferrer" download>
                  <i className="fas fa-download me-2"></i>
                  Descargar
                </a>
              )}
            </div>
          </div>
        </div>
      </div>

      {/* Documentos */}
      <div className="row mb-4">
        <div className="col-12">
          <h5 className="text-secondary mb-3">
            <i className="fas fa-file-alt me-2"></i>
            Documentos
          </h5>
          <div className="row g-3">
            {orderData && orderData[0] && orderData[0].Documentos.map((documento, index) => {
              // Mapear colores de Bootstrap a clases completas
              let colorClass = '';
              switch(documento.Color) {
                case 'primary': colorClass = 'bg-primary text-white'; break;
                case 'secondary': colorClass = 'bg-secondary text-white'; break;
                case 'success': colorClass = 'bg-success text-white'; break;
                case 'danger': colorClass = 'bg-danger text-white'; break;
                case 'warning': colorClass = 'bg-warning text-dark'; break;
                case 'info': colorClass = 'bg-info text-dark'; break;
                case 'light': colorClass = 'bg-light text-dark'; break;
                case 'dark': colorClass = 'bg-dark text-white'; break;
                default: colorClass = 'bg-primary text-white'; break;
              }
              
              return (
                <div className="col-md-4 col-lg-3" key={index}>
                  <div className={`card h-100 border-start border-${documento.Color} border-start-4 shadow-sm`}>
                    {/* Cambio 1: Aplicar color de fondo completo en el header */}
                    <div className={`card-header ${colorClass} py-2`}>
                      <div className="d-flex justify-content-between align-items-center">
                        <h6 className="mb-0 text-truncate">{documento.Documento}</h6>
                        {documento.TipoObjeto && (
                          <span className="badge bg-light text-dark small">
                            <i className={getIconForTipoObjeto(documento.TipoReferenciaBoton)}></i>
                          </span>
                        )}
                      </div>
                    </div>
                    <div className="card-body d-flex flex-column">
                      <div className="mb-2">
                        <small className="text-muted">Referencia:</small>
                        <p className="fw-semibold mb-1">{documento.Referencia}</p>
                      </div>
                      {/* <div className="mb-2">
                        <small className="text-muted">Tipo:</small>
                        <p className="text-truncate">
                          {documento.TipoObjeto && (
                            <span className="badge bg-info-subtle text-info">
                              <i className={`${getIconForTipoObjeto(documento.TipoReferenciaBoton)} me-1`}></i>
                              {documento.TipoObjeto}
                            </span>
                          )}
                        </p>
                      </div> */}
                      <div className="mb-2">
                        <small className="text-muted">Comentarios:</small>
                        <p className="text">{documento.Comentarios}</p>
                      </div>
                      <div className="mt-auto">
                        <small className="text-muted">{documento.FechaHora}</small>
                        {documento.TextoBoton === 'VER' && (
                          <button
                            className="btn btn-warning w-100 mt-2"
                            onClick={() => handlePreview(documento.ValorBoton, documento.TipoReferenciaBoton, 'pdf')}
                          >
                            <i className={`${getIconForTipoObjeto(documento.TipoReferenciaBoton)} me-2`}></i>
                            {documento.TipoReferenciaBoton === 'WEB' ? 'Abrir Enlace' : 'Vista Previa'}
                          </button>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>

      {/* Mercancía y Bitácora */}
      <div className="row g-4">
        {/* Mercancía */}
        <div className="col-lg-6">
          <div className="card border-0 shadow-sm h-100">
            <div className="card-header bg-success text-white rounded-top">
              <div className="d-flex justify-content-between align-items-center">
                <h5 className="mb-0">
                  <i className="fas fa-boxes me-2"></i>
                  Mercancía
                </h5>
                <span className="badge bg-light text-dark">
                  {productosFiltrados().length} productos
                </span>
              </div>
            </div>
            <div className="card-body p-0 position-relative">
              <div className="table-responsive">
                <table className="table table-hover mb-0">
                  <thead className="table-light">
                    <tr>
                      <th>Código</th>
                      <th>Descripción</th>
                      <th>Precio Unitario</th>
                      <th>Cantidad</th>
                      <th>Total Línea</th>
                    </tr>
                  </thead>
                  <tbody>
                    {productosFiltrados().length > 0 ? (
                      productosFiltrados().map((producto, index) => (
                        <tr key={index}>
                          <td className="text-muted">{producto.Codigo}</td>
                          <td>
                            <div className="text-truncate" style={{ maxWidth: '150px' }} title={producto.Descripcion}>
                              {producto.Descripcion}
                            </div>
                          </td>
                          <td className="fw-semibold">Q {parseFloat(producto.Precio).toFixed(2)}</td>
                          <td>
                            <span className="badge bg-info-subtle text-info">
                              {producto.CantidadFactura}
                            </span>
                          </td>
                          <td className="fw-bold text-success">
                            Q {calcularTotalLinea(producto.Precio, producto.CantidadFactura)}
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="5" className="text-center py-4 text-muted">
                          <i className="fas fa-box-open fa-2x mb-2"></i>
                          <p>No hay productos con precio y cantidad definidos</p>
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
              
              {/* Cambio 2: Mostrar total general en esquina inferior derecha */}
              {productosFiltrados().length > 0 && (
                <div className="position-absolute bottom-0 end-0 m-3">
                  <div className="bg-success text-white rounded-pill px-4 py-2 shadow">
                    <strong>Total: Q {calcularTotalGeneralProductos()}</strong>
                  </div>
                </div>
              )}
            </div>
            <div className="card-footer bg-light d-flex justify-content-between align-items-center">
              <small className="text-muted">
                Mostrando {productosFiltrados().length} productos válidos
              </small>
              {productosFiltrados().length > 0 && (
                <small className="text-muted d-md-none">
                  Total: Q {calcularTotalGeneralProductos()}
                </small>
              )}
            </div>
          </div>
        </div>

        {/* Bitácora */}
        <div className="col-lg-6">
          <div className="card border-0 shadow-sm h-100">
            <div className="card-header bg-info text-white rounded-top">
              <h5 className="mb-0">
                <i className="fas fa-history me-2"></i>
                Bitácora
              </h5>
            </div>
            <div className="card-body p-0">
              <div className="table-responsive">
                <table className="table table-hover mb-0">
                  <thead className="table-light">
                    <tr>
                      <th width="60">Paso</th>
                      <th>Descripción</th>
                      <th width="120">Fecha</th>
                    </tr>
                  </thead>
                  <tbody>
                    {orderData && orderData[0] && orderData[0].Bitacora.map((documento, index) => (
                      <tr key={index}>
                        <td>
                          <span className="badge bg-primary rounded-circle">{index + 1}</span>
                        </td>
                        <td>{documento.Descripcion}</td>
                        <td className="text-muted">
                          <small>{documento.Fecha}</small>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>

     

      {/* Footer */}
      <footer className="mt-5 pt-4 border-top text-center text-muted">
        <p className="mb-0">
          © {new Date().getFullYear()} Sistema de Gestión de Órdenes
        </p>
        <small>Orden #{orderId} - Última actualización: {new Date().toLocaleDateString()}</small>
      </footer>
    </div>
  );
};

export default DashboardOM;